import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// Lazy-loaded: keeps analyticsService out of the main bundle (~18KB saved)
const trackPageView = (path: string) =>
  import('../services/analyticsService').then(m => m.trackPageView(path));

/**
 * ScrollToTop component
 * Automatically scrolls to top of page when route changes,
 * and fires a GA4 page_view event for every navigation.
 *
 * If the URL contains a hash fragment (e.g. #after-submit),
 * scrolls to that element instead of the top.
 */
export function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            // Delay slightly to allow the page to render before scrolling
            const timer = setTimeout(() => {
                const element = document.getElementById(hash.slice(1));
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
            return () => clearTimeout(timer);
        } else {
            window.scrollTo(0, 0);
        }
        trackPageView(pathname);
    }, [pathname, hash]);

    return null;
}

export default ScrollToTop;